import React, { Component, Suspense, lazy } from "react";
import styles from "./register.module.css";
import Input from "src/components/input/input";
import InputEmail from "src/components/inputEmail/inputEmail";
import Dropdown from "src/components/dropdown/dropdown";
import { fromArrayToObject, getDefaultCountryFromBrowser } from "src/utils/country-utils";
import countryList from "iso-3166-country-list";
import { VOLUME } from "src/app-constants";
import { ButtonBase } from "@material-ui/core";
import { postRegisterStart, resetResponseFirst } from "src/redux/actions/action-register";
import classnames from "classnames";
import { connect } from "react-redux";
import { INITIAL_STATE } from "src/redux/reducers/initial-state";
import { _t } from "src/redux/store";
import ReCAPTCHA from "react-google-recaptcha";
import { getAgentInfo } from "src/redux/actions/action-register";
import { Options } from "src/model/myTypes";
import Settings from "src/settings/settings-class";
import InputPhone from "src/components/inputPhone/inputPhone";
import InputDate from "src/components/inputDate/inputDate";
import InputCpf from "src/components/inputCpf/inputCpf";
import InputTermsAndConditions from "src/components/inputTermsAndConditions/inputTermsAndConditions";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { AFFILIATE_COOKIE_NAME, setCookie } from "src/utils/cookie-utils";

type Props = RouteComponentProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const Confirmation = lazy(() => import("./confirmation"));

const CURRENCIES = Settings.data.currenciesList;

type State = {
  form: {
    name: string;
    surname: string;
    email: string;
    repeatedEmail: string;
    country: string;
    currency: string;
    phoneNumber: { value: string, valid: boolean };
    birthdate: string;
    cpf: { value: string, valid: boolean };
    volume: string;
    isTermsAccepted: boolean;
  };
  loading: boolean;
  isValid: boolean;
  success: boolean;
  isVerifed: string | null;
};

class Register extends Component<Props, State> {
  private appName = Settings.data.siteName;
  private shouldAskVolume = Settings.data.registerAskVolume;
  private currencyOptions: Options = {};

  constructor(props: Props) {
    super(props);
    this.state = {
      form: {
        name: "",
        surname: "",
        email: "",
        repeatedEmail: "",
        country: getDefaultCountryFromBrowser(),
        currency: this.getDefaultCurrencyFromBrowserLang(),
        phoneNumber: { value: "", valid: true },
        birthdate: "",
        cpf: { value: "", valid: true },
        volume: "",
        isTermsAccepted: false,
      },
      loading: false,
      isValid: false,
      isVerifed: null,
      success: this.props.response,
    };
    if (this.shouldAskVolume === false) {
      this.state.form.volume = Object.keys(VOLUME)[0];
    }
    this.props.getAgentInfo(); // get currencies and field visibilities
    this.parseAffIdFromURL(); // saves a cookie so that later is gets retrieved when registering new user
  }

  componentDidMount(): void {
    this.buildCurrencyOptions();
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.form !== this.state.form) {
      this.validateForm();
    }
    if (prevProps.response !== this.props.response || prevProps.message !== this.props.message) {
      if (this.props.forceEmailValidation) {
        this.setState({
          success: this.props.response,
          isValid: false,
          loading: false,
        });
      } else {
        if (this.props.response === true) {
          this.props.history.push('/user-confirmation?h=' + this.props.message + '&lang=' + this.props.lang)
        }
      }
    }
    if (prevProps.currencies !== this.props.currencies) {
      this.buildCurrencyOptions();
    }
  }

  componentWillUnmount() {
    this.props.resetResponseFirst();
  }

  parseAffIdFromURL(): void {
    try {
      const queryParams = new URLSearchParams(this.props.location.search);
      const affid = queryParams.get(AFFILIATE_COOKIE_NAME);
      if (!!affid) {
        setCookie(AFFILIATE_COOKIE_NAME, affid, false, { expires: 30 });
      }
    } catch (error) {
      // do nothing
    }
  }

  getDefaultCurrencyFromBrowserLang(): string {
    let currency = "";
    const browserLocale = Intl.DateTimeFormat().resolvedOptions().locale.toUpperCase();
    switch (true) {
      case browserLocale.startsWith("PT"):
        currency = "BRL";
        break;
      case browserLocale.startsWith("EN"):
        currency = "USD";
        break;
      case browserLocale.startsWith("ES"):
        currency = "USD";
        break;
      default:
        currency = "USD";
        break;
    }
    if (CURRENCIES.indexOf(currency) !== -1) {
      return currency;
    } else {
      return ""; // empty string is not default currency chosen
    }
  }

  validateForm = () => {
    var isValid = true;

    Object.keys(this.state.form).forEach((key) => {
      if (this.skipFormFiledValidation(key)){
        return;
      }
      if (this.state.form[key as keyof State["form"]] === "") {
        isValid = false;
      } else if (key === 'isTermsAccepted') {
        if (this.state.form[key as keyof State["form"]] === false) {
          isValid = false;
        }
      }
    });

    this.setState({ isValid: isValid });
  };

  skipFormFiledValidation(fieldKey: string){
    let skip = false;
    
    if (
      this.props.birthdateInput === false 
      && fieldKey.startsWith("birthdate")
    ) {
      skip = true;
    }
    if (
      this.props.cpfInput === false 
      && fieldKey.startsWith("cpf")
    ) {
      skip = true;
    }
    if (
      this.props.forceEmailValidation
      && fieldKey.startsWith("repeatedEmail")
    ) {
      skip = true;
    }
    return skip;
  }

  handleOnChange = (name: keyof State["form"], newValue: string | boolean, isValid?: boolean) => {
    if (this.props.message !== "") {
      this.props.resetResponseFirst();
    }
    if (isValid !== undefined && !!this.state.form[name] && this.state.form[name].hasOwnProperty("value")){
      this.setState({
        form: {
          ...this.state.form,
          [name]: {value:newValue, valid:isValid},
        },
      });
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [name]: newValue,
        },
      });
    }
  };

  handleOnSubmit = () => {
    this.props.postRegisterStart(
      this.state.form.email,
      this.state.form.name,
      this.state.form.surname,
      this.state.form.country,
      this.state.form.currency,
      this.state.form.phoneNumber.value,
      this.state.form.birthdate,
      this.state.form.cpf.value,
      this.state.form.volume,
      this.state.form.isTermsAccepted,
      this.props.lang,
      this.state.isVerifed as string
    );

    this.setState({ loading: true });
  };

  onChangeRecaptcha = (token: string | null) => {
    if (token !== null) {
      this.setState({ isVerifed: token });
    } else {
      this.setState({ isVerifed: null });
    }
  };

  buildCurrencyOptions(): void {
    const curOpt: Options = {};
    // Build currency options coming from the agent-info api
    this.props.currencies.forEach((cur) => {
      curOpt[cur] = cur;
    });
    // Fallback in case the agent-info api isn't working correctly
    if (Object.keys(curOpt).length === 0) {
      CURRENCIES.forEach((cur) => {
        curOpt[cur] = cur;
      });
    }
    // Choose automatically one currency in case there's only one
    if (Object.keys(curOpt).length === 1 && this.state.form.currency.toLowerCase() !== Object.values(curOpt)[0].toLowerCase()) {
      this.setState({
        form: {
          ...this.state.form,
          currency: Object.values(curOpt)[0]
        }
      });
    }
    this.currencyOptions = curOpt;
  }

  render() {
    return (
      <div className={styles.container}>
        <Suspense fallback={<div className="loader"></div>}>
          {this.state.success === false ? (
            <div className={styles.wrapper}>
              <h3 className={styles.title}>
                {_t.translate("Create your {{appName}} account", {
                  appName: this.appName,
                })}
              </h3>
              <div className={styles.message}>
                {this.props.message === "" ? (
                  <p>{_t.translate("It only takes a minute")}</p>
                ) : (
                  <>
                    <p className={styles.error}>
                      {_t.translate(
                        "We detected that you already have a {{appName}} account and we now resend an email with your details.",
                        { appName: this.appName }
                      )}
                    </p>
                    <p className={styles.error}>
                      {_t.translate(
                        'Please check your email to confirm your identity (Please check in the "Spam" box)'
                      )}{" "}
                    </p>
                  </>
                )}{" "}
              </div>
              <div className={styles.form}>
                <Input
                  name={"name"}
                  value={this.state.form.name}
                  label={_t.translate("First Name")}
                  handleOnChange={this.handleOnChange}
                />
                <Input
                  name={"surname"}
                  value={this.state.form.surname}
                  label={_t.translate("Last Name")}
                  handleOnChange={this.handleOnChange}
                />
                <InputEmail
                  name={"email"}
                  value={this.state.form.email}
                  label={"Email"}
                  handleOnChange={this.handleOnChange}
                  repeatedEmail={this.state.form.repeatedEmail}
                />
                {this.props.forceEmailValidation === false ? (
                  <InputEmail
                    name={"repeatedEmail"}
                    value={this.state.form.repeatedEmail}
                    label={_t.translate("Confirm Email")}
                    handleOnChange={this.handleOnChange}
                    repeatedEmail={this.state.form.email}
                  />
                ) : ''}
                <Dropdown
                  name={"country"}
                  options={fromArrayToObject(countryList)}
                  value={this.state.form.country}
                  label={_t.translate("Country")}
                  handleOnChange={this.handleOnChange}
                />
                {this.props.cpfInput === true ?
                  <InputCpf
                    name={"cpf"}
                    validateCpfFormat={this.state.form.country === "BR"}
                    value={this.state.form.cpf.value}
                    label={this.state.form.country === "BR" ? _t.translate("CPF") : _t.translate("id-card-name-EN")}
                    handleOnChange={this.handleOnChange}
                  />
                  : ''}
                <Dropdown
                  name={"currency"}
                  options={this.currencyOptions}
                  value={this.state.form.currency}
                  label={_t.translate("Currency")}
                  handleOnChange={this.handleOnChange}
                />
                {this.props.phoneInput === true ?
                  <InputPhone
                    name={"phoneNumber"}
                    value={this.state.form.phoneNumber.value}
                    label={_t.translate("Phone Number")}
                    country={this.state.form.country}
                    handleOnChange={this.handleOnChange}
                    regex="^(\+?\d{5,15})?$"
                    regexErrorMessage={_t.translate("Number between 5 and 15 digits, can start with '+'")}
                  />
                  : ''}
                {this.props.birthdateInput === true ?
                  <InputDate
                    name={"birthdate"}
                    value={this.state.form.birthdate}
                    label={_t.translate("Birthdate") + " " + _t.translate("(DD-MM-YYYY)")}
                    handleOnChange={this.handleOnChange}
                  />
                  : ''}
                {this.shouldAskVolume === true && (
                  <Dropdown
                    name={"volume"}
                    options={VOLUME}
                    value={this.state.form.volume}
                    label={_t.translate("Expected monthly volume")}
                    handleOnChange={this.handleOnChange}
                  />
                )}
                <InputTermsAndConditions 
                name={"isTermsAccepted"} 
                value={this.state.form.isTermsAccepted} 
                handleOnChange={this.handleOnChange}/>
              </div>
              <ReCAPTCHA
                sitekey={
                  "6Ldo35scAAAAAK-Fg_MnLBn_KTel7mDQytd0-K3o"
                  // process.env.REACT_APP_RECAPTCHA_KEY as string
                }
                onChange={this.onChangeRecaptcha}
                theme="dark"
              />
              <ButtonBase
                className={classnames(
                  styles.btnSubmit,
                  (!this.state.isVerifed || !this.state.isValid) && styles.isDisabled
                )}
                onClick={this.handleOnSubmit}
                disabled={!this.state.isValid || !this.state.isVerifed}
              >
                {this.state.loading ? (
                  <div className={classnames("loader", styles.loader)}></div>
                ) : (
                  _t.translate("SEND")
                )}
              </ButtonBase>
            </div>
          ) : (
            <Confirmation />
          )}
        </Suspense>
      </div>
    );
  }
}
const mapStateToProps = (state: typeof INITIAL_STATE) => {
  return {
    response: state.register.registerStartResponse,
    lang: state.settings.userLang,
    message: state.register.registerStartMessage,
    currencies: state.register.availableCurrencies,
    phoneInput: state.register.phoneNumberResgistration,
    birthdateInput: state.register.birthdateResgistration,
    cpfInput: state.register.cpfResgistration,
    forceEmailValidation: state.register.forceEmailValidation,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getAgentInfo: () => {
      dispatch(getAgentInfo());
    },
    postRegisterStart: (
      email: string,
      firstname: string,
      lastname: string,
      country: string,
      currency: string,
      phoneNumber: string,
      birthdate: string,
      cpf: string,
      turnover: string,
      isTermsAccepted: boolean,
      lang: string,
      token: string
    ) => {
      dispatch(postRegisterStart(email, firstname, lastname, country, currency, phoneNumber, birthdate, cpf, turnover, isTermsAccepted, lang, token));
    },
    resetResponseFirst: () => dispatch(resetResponseFirst()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));
